import React, { useEffect } from 'react';
import { HereYourPlans } from '@features/onboarding/components/7-finish/HereYourPlans';
import { ExcuseStep } from '@features/onboarding/components/7-finish/components/excuse-step/ExcuseStep';
import { applicationService } from 'src/services/application';
import { useApplicationStore } from 'src/store/application';
import { usePaymentStore } from '@features/onboarding/components/7-finish/store/payment';
import { useFinalSubmissionStore } from 'src/store/final-submission';

export const CoverageReassuranceWithExcuse = () => {
  const { currentApplicationId, hasCompletedApplication } = useApplicationStore();
  const { paymentMethodId } = usePaymentStore();
  const { isSubmittingApplication } = useFinalSubmissionStore();

  useEffect(() => {
    if (paymentMethodId || isSubmittingApplication || hasCompletedApplication) {
      console.log('skipping getQuote');
      return;
    }
    
    console.log('currentApplicationId', currentApplicationId);
    if (currentApplicationId) {
      applicationService.getQuote(currentApplicationId);
    }
  }, [currentApplicationId, paymentMethodId, isSubmittingApplication, hasCompletedApplication])
  return (
    <div className="flex flex-col h-full">
      <HereYourPlans />
      <div className="mt-0">
        <ExcuseStep hideTitle={true} />
      </div>
    </div>
  );
}; 